

interface BreadcrumbItem {
  name: string;
  href: string;
}

interface SEOBreadcrumbsProps {
  items: BreadcrumbItem[];
}

export function SEOBreadcrumbs({ items }: SEOBreadcrumbsProps) {
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": `https://lexgordonexecutive.com.au${item.href === "/" ? "" : item.href}`,
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <nav aria-label="Breadcrumb" className="article-breadcrumb container mx-auto px-6 lg:px-8 pt-6">
        <ol className="flex items-center gap-2 text-xs text-muted-foreground">
          {items.map((item, index) => (
            <li key={item.href} className="flex items-center gap-2">
              {index > 0 && <span aria-hidden="true">/</span>}
              {index === items.length - 1 ? (
                <span className="text-muted-foreground" aria-current="page">{item.name}</span>
              ) : (
                <a href={item.href} className="hover:text-foreground transition-colors">{item.name}</a>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}
